// extracted by mini-css-extract-plugin
export default {"textsAndPhone":"GenerateQR_textsAndPhone__HyI3L","phone":"GenerateQR_phone__kxB6H","arrow":"GenerateQR_arrow__lejk3","texts":"GenerateQR_texts__CQQaq"};